// leaf-town - boot + main loop
(function () {
  'use strict';
  const G = window.G, STEP = 1 / 60;
  const Q = (G.query = new URLSearchParams(location.search));

  // ---------- scene switching with a diamond wipe ----------
  let trans = null;
  G.scene = { update() {}, draw() {} };
  G.setScene = (s) => { G.scene = s; if (G.onScene) G.onScene(s); if (s.enter) s.enter(); };   // onScene: the net bridge hears about every scene change
  // make() builds the next scene while the screen is covered
  G.go = (make, o) => {
    if (trans) return;
    o = o || {};
    trans = { t: 0, phase: 0, make, speed: o.speed || 2.6, col: o.col || '#0d0a12', hold: o.hold || 0.08 };
    G.input.locked = true;
  };
  G.transitioning = () => !!trans;
  function stepTrans(dt) {
    if (!trans) return;
    if (trans.phase === 0) {
      trans.t += dt * trans.speed;
      if (trans.t >= 1) { trans.t = 1; trans.phase = 1; trans.wait = trans.hold; G.setScene(trans.make()); }
    } else if (trans.phase === 1) {
      trans.wait -= dt;
      if (trans.wait <= 0) trans.phase = 2;
    } else {
      trans.t -= dt * trans.speed;
      if (trans.t <= 0) { trans = null; G.input.locked = false; }
    }
  }

  G.save.load();
  // favicon: your friend, naturally
  (() => {
    const c = G.makeCanvas(32, 32);
    c.g.fillStyle = '#17131f'; c.g.fillRect(0, 0, 32, 32);
    G.drawHero(c.g, 16, 26, { u: 2, face: 0, eyeX: 0 });
    const l = document.createElement('link'); l.rel = 'icon'; l.href = c.toDataURL(); document.head.appendChild(l);
  })();

  if (Q.has('mute')) G.audio.muted = true;

  // ---------- pick the first scene ----------
  if (Q.has('sheet')) G.setScene({ update() {}, draw(g) { G.debugSheet(g); } });
  else if (G.Scenes) G.setScene(G.Scenes.boot());

  let acc = 0, last = performance.now();
  const manual = Q.has('manual');             // tests drive the clock themselves
  G.render = () => {
    G.ug.clearRect(0, 0, G.W, G.H);
    G.ambient = null;
    G.scene.draw(G.g, G.ug);
    if (trans) G.wipe(G.ug, G.ease.io(G.clamp(trans.t, 0, 1)), trans.col, trans.phase === 2 ? -1 : 1);
    G.present();
  };
  G.step = (n, quiet) => {
    for (let i = 0; i < n; i++) { G.input.poll(); stepTrans(STEP); G.scene.update(STEP); G.time += STEP; G.frame++; }
    if (manual && !quiet) G.render();
  };
  function frame(now) {
    requestAnimationFrame(frame);
    let dt = (now - last) / 1000;
    last = now;
    if (manual) return;
    if (dt > 0.1) dt = 0.1;
    acc += dt;
    let n = 0;
    while (acc >= STEP && n < 4) { G.step(1); acc -= STEP; n++; }
    if (n === 4) acc = 0;
    G.render();
  }
  requestAnimationFrame(frame);
})();

